import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Homee() {
  const [users, setUsers] = useState([]);
  const [activeLetter, setActiveLetter] = useState(null);
  const navigate = useNavigate();

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const fetchByLetter = (letter) => {
    setActiveLetter(letter);

    // If letter is "#", call /findbysymbol
    const endpoint =
      letter === "#"
        ? `${process.env.REACT_APP_API_URL}/findbysymbol`
        : `${process.env.REACT_APP_API_URL}/findbyletter/${letter}`;

    fetch(endpoint)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch");
        }
        return res.json();
      })
      .then((data) => setUsers(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("Failed to fetch:", err);
        setUsers([]); // clear users on error
      });
  };

  const handleClick = (userId) => {
    navigate(`/user/${userId}`);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Browse Escorts by Letter or Symbol (#)</h2>

      {/* Alphabet row */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "20px",
        }}
      >
        {alphabet.map((letter) => (
          <button
            key={letter}
            onClick={() => fetchByLetter(letter)}
            style={{
              padding: "8px 12px",
              borderRadius: "6px",
              border:
                activeLetter === letter
                  ? "2px solid #1976d2"
                  : "1px solid #ccc",
              background:
                activeLetter === letter ? "#e3f2fd" : "#f9f9f9",
              cursor: "pointer",
              fontWeight: activeLetter === letter ? "600" : "400",
            }}
          >
            {letter}
          </button>
        ))}

        {/* Symbols button */}
        <button
          key="#"
          onClick={() => fetchByLetter("#")}
          style={{
            padding: "8px 12px",
            borderRadius: "6px",
            border:
              activeLetter === "#"
                ? "2px solid #1976d2"
                : "1px solid #ccc",
            background:
              activeLetter === "#"
                ? "#e3f2fd"
                : "#f9f9f9",
            cursor: "pointer",
            fontWeight: activeLetter === "#" ? "600" : "400",
          }}
        >
          #
        </button>
      </div>

      {/* Results */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {users.length > 0 ? (
          users.map((user, idx) => (
            <div
              key={idx}
              onClick={() => handleClick(user._id)}
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "10px 15px",
                background: "#f1f1f1",
                cursor: "pointer",
                minWidth: "150px",
              }}
            >
              <strong>{user.name}</strong> ({user.review_count ?? 0} reviews)
            </div>
          ))
        ) : (
          activeLetter && (
            <p>No escorts found starting with "{activeLetter}"</p>
          )
        )}
      </div>
    </div>
  );
}

export default Homee;
